<ion-content id="content" no-bounce>
  <ion-router-outlet></ion-router-outlet>
</ion-content>
